import logo from 'assets/greenamex-logo.png'

const AuthLayout = ({ children }) => {
  return (
    <div className='font-nunito min-h-screen flex items-center justify-center bg-greenPrimary'>
      <div className='bg-white p-8 rounded-xl shadow-md w-96 flex flex-col items-center'>
        <img src={logo} alt='App Logo' className='w-24 h-24 mb-4' />
        {children}
      </div>
    </div>
  )
}

export default AuthLayout
